import { Card, CardActions, CardContent, Grid, Skeleton, Stack } from '@mui/material'

export default function CreditCardSkeleton() {
  return <Grid item xs={12} md={6} lg={4}>
    <Card elevation={0} sx={{
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: '#fff',
      '& .MuiSkeleton-root': {
        backgroundColor: '#dedede',
      },
    }}>
      <CardContent sx={{ flexGrow: 1 }}>
        <Stack spacing={2}>
          <Stack direction="row" spacing={1} alignItems="center">
            <Skeleton variant="rounded" width={38} height={24} />
            <Skeleton variant="text" width="78%" height={24} />
          </Stack>
          <Stack spacing={1} alignItems="flex-start">
            <Skeleton variant="text" width="52%" height={22.5} />
            <Skeleton variant="rounded" width={88} height={24} />
          </Stack>
        </Stack>
      </CardContent>
      <CardActions sx={{ minHeight: 42, backgroundColor: 'rgba(0, 0, 0, 0.11)' }} />
    </Card>
  </Grid>
}
